import { Component, Inject, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { KanbanService } from '../kanban.service';
import { LoginService } from '../login.service';
import { UtilsService } from '../utils.service';

@Component({
  selector: 'app-course-dialog-component',
  templateUrl: './dialog-overview-example-dialog.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: []
})
export class CourseDialogComponent implements AfterViewInit {
  public projeto: any;
  public atividade: Object = {
    id: 0,
    descricao: "",
    detalhes: "",
    dataPrevistaInicio: "",
    dataPrevistaTermino: ""
  };
  public edicaoTarefa:any;
  public _tarefas: Array<Object> = [{ id: 0, descricao: '', digitacao: true, dataPrevistaInicio: "", check: false }];
  public atividades_dados: boolean = true;
  public atividades_checklist: boolean = false;
  public cadastro = { titulo: String, tipo_atividade: Number, data_prev: Date, detalhes: String };

  public _checklist: any = [{
    id: 1,
    descricao: "Atividade 1"
  }, {
    id: 2,
    descricao: "Atividade 2"
  }];

  envolvidos: any[];
  _novoEnvolvido: boolean = false;
  public envolvido_nome: string;
  public papel_projeto: string;
  dadosProjeto:any;

  constructor(private dialogRef: MatDialogRef<CourseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private login: LoginService,
    private kanban: KanbanService) {

    //console.log("parameter", this.data);

    this.projeto = this.data["projeto"];
    delete this.data["projeto"];
    this.atividade = this.data;
    this.dadosProjeto = this.data["dadosProjeto"];
console.log(this.atividade);
    if (this.data["novocadastro"] == "true")
      this.atividade["dataPrevistaInicio"] = this.dadosProjeto["dataInicio"];

    if (this.data.tarefas != undefined)
      if (this.data.tarefas.length > 0) {
        this._tarefas = this.data.tarefas;
        //console.log(this._tarefas);
      }
  }

  ngOnInit() { }

  closeAll(): void {
    this.dialogRef.close();
  }

  isSelected(index: any) {
    if (index == 1)
    setTimeout(function(){
      UtilsService.setDate();
    },500);
  }

  ngAfterViewInit() {
   // eval('document.getElementsByClassName("cdk-global-overlay-wrapper")[0].style.marginTop = "76px";');
    eval('document.getElementsByClassName("cdk-global-overlay-wrapper")[0].style.backgroundColor = "transparent !important";');
    eval('document.getElementsByClassName("mat-tab-header")[0].style = "background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(87,108,117,1) 0%, rgba(37,50,55,1) 100.2% ) !important;color:white;font-weight:bold;"');
    eval('document.getElementsByClassName("mat-tab-body-content")[0].style = "padding-top:25px;"')
    eval('document.getElementsByClassName("mat-tab-label")[0].style = "width: 160px !important;"');

    if (this.atividade["novocadastro"] == "true") {
      eval('document.getElementsByClassName("mat-tab-label")[1].style= "display: none !important"');
    } else {
      eval('document.getElementsByClassName("mat-tab-label")[1].style= "width: 160px !important"');
      eval('document.getElementsByClassName("mat-tab-label-content")[1].style = "position: absolute;top: 15px;"');
    }

    eval('document.getElementsByClassName("mat-tab-label-content")[0].style = "position: absolute;top: 15px;"');

    eval('document.getElementsByClassName("mat-tab-group")[0].style = "margin: 0 auto;"')
    eval('document.getElementsByClassName("thor-modal-material__wrapper")[0].style = "width:100%;height:auto;position: relative;top: 0;z-index: 1002;background-color: transparent;"');
    eval('document.getElementsByClassName("mat-tab-list")[0].style = "height: 48px !important;"');
    eval('document.getElementsByClassName("mat-tab-header-pagination")[0].style = "height: 48px !important;"');
    eval('document.getElementsByClassName("mat-tab-label-container")[0].style = "height: 48px !important;"');

    if (window.screen.availWidth <= 900) {
      setTimeout(function() {
        //eval('document.getElementsByClassName("cdk-global-overlay-wrapper")[0].style.width = "100% !important;";');
        eval('document.getElementsByClassName("mat-tab-group")[0].style = "width:100% !important;";');
        eval('document.getElementsByClassName("cdk-overlay-pane")[0].style = "margin: 0 !important;";');
        eval('document.getElementsByClassName("mat-dialog-container")[0].style = "padding:0 !important;";');
        eval('document.getElementsByClassName("mat-tab-body-content")[0].style = "padding-top:25px;height: 83vh;overflow: auto;";');
      }, 500);
    }

    //eval("window.M.Tabs.init(document.querySelectorAll('.tabs'), {});");
    //eval("window.M.FormSelect.init(document.querySelectorAll('select'), {});");

    setTimeout(function() {
      UtilsService.setDate();
      UtilsService.setSelect();
      eval("window.M.Tabs.init(document.querySelectorAll('.tabs'), {});");
    }, 500);
  }

  setDataPrevista(event) {
    let dt = (document.querySelector('#dataPrevistaTermino'+ event.id) != null ? eval("document.getElementById('dataPrevistaTermino" + event.id + "').value") : "").split("/");
    if (dt !== "") {
      event.data_prev_fim_dia = dt[0];
      event.data_prev_fim_mes = dt[1];
      event.data_prev_fim_ano = dt[2];
      event.dataPrevistaTermino = (document.querySelector('#dataPrevistaTermino'+ event.id) != null ? eval("document.getElementById('dataPrevistaTermino" + event.id + "').value") : "");
    } else {
      event.data_prev_fim_dia = "";
      event.data_prev_fim_mes = "";
      event.data_prev_fim_ano = "";
      event.dataPrevistaTermino = "";
    }
  }

  salvarTarefa(tarefa, status?:any) {
    let check = (status !== false ? ( status.target.checked ? true : false) : ( tarefa.id != 0 ? (tarefa.status == 'CONCLUIDA' ? true : false) : false ));
    /*let vdataPrevistaInicio = "";*/
    let vdataPrevistaTermino:any = "";

    if (tarefa["descricao"].trim() == "") {
      UtilsService.alerta('Favor digitar o nome da tarefa!', 'erro');
      return false;
    }

    let dtid = 'dataPrevistaTermino' + tarefa.id;

    vdataPrevistaTermino = (tarefa.dataPrevistaTermino !== undefined && tarefa.dataPrevistaTermino !== null ? tarefa.dataPrevistaTermino : (document.querySelector('#'+dtid) != null ? eval("document.getElementById('" + dtid + "').value") : ""));

    if (vdataPrevistaTermino !== undefined && vdataPrevistaTermino !== null) {
      let proj = JSON.parse(localStorage.getItem('kanban'));

      if (proj.userAdmin == false) {
        let data = vdataPrevistaTermino.split('/');
        data = new Date(data[2], data[1] - 1, data[0]);
        data.setHours(0,0,0,0);
        let dataHoje = new Date();
        dataHoje.setHours(0,0,0,0);

        //console.log(data.toLocaleDateString(), dataHoje.toLocaleDateString(), UtilsService.compareDate(data, dataHoje));
        
        if (data.getTime() !== dataHoje.getTime() && dataHoje > data) {
          UtilsService.alerta('Data de término dessa tarefa expirada!', 'erro');
          return;
        }
      }
    }

    if (check == true) {
      /*vdataPrevistaInicio = tarefa.dataPrevistaInicio;*/
      //vdataPrevistaTermino = tarefa.dataPrevistaTermino;
    } else {

      //console.log(tarefa.dataPrevistaTermino);


      //console.log(document.getElementById(dtid));
      //console.log("document.getElementById('" + dtid + "').value");
      /*vdataPrevistaInicio = eval("document.getElementById('dataPrevistaInicio" + tarefa.id + "').value");*/
      //
    }

    let item = {
      descricao: tarefa["descricao"],
      idUsuario: this.login.getUsuario("id"),
      status: (check == true ? "CONCLUIDA" : "ABERTA"),
      /*dataPrevistaInicio: vdataPrevistaInicio,*/
      dataPrevistaTermino: vdataPrevistaTermino
    };
    //console.log(item);

    if (tarefa["id"] !== 0)
      item["id"] = tarefa.id;

    this.kanban.setTarefa(this.projeto, (this.atividade["id"] != undefined ? this.atividade["id"] : ''), item).subscribe((resp) => {
      for (let taf in this._tarefas) {
        if (this._tarefas[taf]["id"] == resp["id"] || this._tarefas[taf]["id"] == "0") {
          this._tarefas[taf] = resp;
        }
      }

      tarefa.digitacao = false;
      this.edicaoTarefa = undefined;

      //console.log(resp);
      if (tarefa.status !== resp["status"] && resp["status"] == "CONCLUIDA")
        UtilsService.alerta('Tarefa encerrada com sucesso');
      else UtilsService.alerta('Tarefa atualizada com sucesso');

    }, resp => {
      UtilsService.alerta(resp.error.message, 'erro');
    });
  }

  removerTarefa(taf) {
    UtilsService.confirmacao('Atenção', 'Deseja mesmo remover?').then((result) => {
      if (result["value"] == true) {
        this.kanban.removeTarefa(this.projeto, this.atividade["id"], taf.id).subscribe((resp) => {

          for (let idx in this._tarefas) {
            if (this._tarefas[idx]["id"] == taf["id"])
              this._tarefas.splice(parseInt(idx), 1);
          }

          if (this._tarefas.length == 0)
            this.novaTarefa();
          UtilsService.alerta("Tarefa removida com sucesso!");
        }, respError => {
          UtilsService.alerta(respError["error"]["message"], "erro");
        });
      }
    });
  }

  salvarAtividade() {
    let item = {
      descricao: this.atividade["descricao"],
      detalhes: this.atividade["detalhes"],
      idUsuario: this.login.getUsuario("id"),
      dataPrevistaInicio: eval("document.getElementById('dataPrevistaInicio').value"),
      dataPrevistaTermino: eval("document.getElementById('dataPrevistaTermino').value")
    };
    
    console.log(this.atividade["descricao"], item.descricao);

    if (String(item.descricao).trim() == '') {
      UtilsService.alerta("O título não pode ser vazio!", "erro");
      return;
    } else if (String(item.dataPrevistaInicio).trim() == '') {
      UtilsService.alerta("A data de previsão de início não pode ser vazia!", "erro");
      return;
    } else if (String(item.dataPrevistaTermino).trim() == '') {
      UtilsService.alerta("A data de previsão de término não pode ser vazia!", "erro");
      return;
    } else {
      this.kanban.setAtividade(this.projeto, (this.atividade["id"] != undefined ? this.atividade["id"] : ''), item).subscribe((resp) => {

        if (this.atividade["id"] == undefined) {
          eval('document.getElementsByClassName("mat-tab-label")[1].style= "width: 160px !important"');
          eval('document.getElementsByClassName("mat-tab-label-content")[1].style = "position: absolute;top: 15px;"');
          eval('document.getElementsByClassName("mat-tab-label")[1].style.display= ""');
        }

        this.atividade = resp;
        //console.log(resp);

        UtilsService.alerta('Atividade salva com sucesso.');
      }, resp => {
        UtilsService.alerta(resp.error.message, 'erro');
      })
    }
  }

  concluirAtividade() {
    this.kanban.concluirAtividade(this.atividade["id"]);
  }

  novaTarefa() {
    //console.log("novaTarefa");

    for (let taf in this._tarefas) {
      if (this._tarefas[taf]["id"] == 0) {
        UtilsService.alerta("Confirme a tarefa em aberto primeito para inserir uma nova!", "erro");
        return false;
      }
    }
    this._tarefas.push({ id: 0, descricao: "", digitacao: true, check: false });
    setTimeout(function(){
      UtilsService.setDate();
    }, 500);
  }

  cancelarEdicao(taf) {
    taf.digitacao = false;
    this.edicaoTarefa = undefined;
  }

  editarTarefa(taf) {
    for (let tarefa in this._tarefas) {
      this._tarefas[tarefa]["digitacao"] = false;
    }

    this.edicaoTarefa = taf;
    taf.digitacao = true;

    setTimeout(function() {
      UtilsService.setDate();
    }, 500);
  }

  public atividades(opcao) {
    switch (opcao) {
      case "checklist":
        this.atividades_checklist = true;
        this.atividades_dados = false;

        this._checklist = [{
          id: 1,
          descricao: "Atividade 1"
        }, {
          id: 2,
          descricao: "Atividade 2"
        }];

        break;
      default:
        this.atividades_checklist = false;
        this.atividades_dados = true;
        break;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(this.atividade);
  }

  sair() {
    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close(this.atividade);
  }

}